var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokRoundedSquareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 116.056,
    ry: 116.056
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2DCCD3",
    fillRule: "nonzero",
    d: "M348.868 152.076c12.815 13.213 28.795 21.265 44.9 24.93v-9.922c-15.132-1.073-30.964-5.834-44.9-15.008zm-92.569-65.444v221.885c0 29.069-20.892 47.767-46.296 47.767-8.427 0-16.43-1.969-23.386-5.609 8.826 11.269 22.762 17.751 38.045 17.751 25.405 0 46.297-18.698 46.297-47.793V98.748h40.263a110.44 110.44 0 01-2.693-12.116h-52.23zm-33.033 128.992V204.63c-5.086-.848-10.172-1.122-14.385-1.122-57.316 0-105.309 45.998-105.309 103.04 0 37.446 18.225 69.457 45.923 88.405-19.296-19.147-31.263-45.948-31.263-76.289 0-56.943 47.843-102.915 105.034-103.04z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1204A",
    fillRule: "nonzero",
    d: "M314.438 304.852c0 70.854-54.199 108.4-105.283 108.4-22.114 0-42.657-6.681-59.66-18.299 19.097 18.947 45.375 30.415 74.319 30.415 51.084 0 105.284-37.546 105.284-108.399V201.514c-5.086-3.441-9.973-7.455-14.66-12.142v115.48zm-127.82 45.824c-6.233-7.879-9.948-18.076-9.948-30.043 0-33.582 26.252-51.332 61.255-47.643v-56.244c-5.085-.847-10.171-1.122-14.41-1.122h-.249v45.225c-35.003-3.664-61.256 14.061-61.256 47.668 0 19.645 10.048 34.554 24.608 42.159zm207.151-173.67v42.009c-23.261 0-45.275-4.438-64.671-17.501 22.587 22.587 49.986 29.642 79.33 29.642V179.2a90.834 90.834 0 01-14.659-2.194zm-44.901-24.93c-12.391-12.74-21.84-30.292-25.679-53.328h-11.967c6.831 24.906 20.892 42.283 37.646 53.328z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M209.155 413.252c51.083 0 105.283-37.547 105.283-108.4v-115.48c4.688 4.687 9.574 8.701 14.66 12.141 19.396 13.065 41.41 17.502 64.671 17.502v-42.009c-16.106-3.664-32.087-11.717-44.901-24.93-16.754-11.045-30.815-28.422-37.646-53.328h-40.263v221.886c0 29.094-20.893 47.792-46.297 47.792-15.283 0-29.219-6.482-38.045-17.751-14.559-7.603-24.606-22.513-24.606-42.158 0-33.607 26.252-51.333 61.255-47.668v-45.225c-57.192.125-105.035 46.098-105.035 103.04 0 30.341 11.967 57.141 31.265 76.288 17.002 11.618 37.545 18.3 59.659 18.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokRoundedSquareIcon);
export default __webpack_public_path__ + "static/media/tiktok-rounded-square-icon.c713223fe162b567a4609e2f9af59deb.svg";
export { ForwardRef as ReactComponent };